<template>
  <div id="home-screen">
    <div class="va-row">
      <div class="flex md12 xs12">
        <div v-if="isLoading">
          <spring-spinner slot="loading" :animation-duration="2500" :size="70" />
        </div>

        <vuestic-widget v-if="!isLoading" :headerText="$t(`home.title`, { name: `TODO name` })">
          <templated-data-table
            :apiMode="apiMode"
            :tableFields="tableFields"
            :itemsPerPage="itemsPerPage"
            :tableData="tableData"
            :dataProvider="dataProvider"
            :paginationPath="paginationPath"
            :queryParams="queryParams"
            @vuestic:row-dblclicked="openCompanyDetails"
            :initialPage="initialPage"
            :dataModeFilterableFields="[`title`]"
          >
            <template slot="updatedAt" slot-scope="props">
              <div class="date-cell">{{ props.rowData.updatedAt }}</div>
            </template>

            <template slot="title" class="date-cell" slot-scope="props">
              <div class="date-cell">{{ props.rowData.title }}</div>
            </template>

            <template slot="unread" slot-scope="props">
              <div class="date-cell">{{ props.rowData.unread }}</div>
            </template>

            <template slot="edit" slot-scope="props">
              <div class="vuestic-icon edit-icon text-center">
                <span @click="editCompany(props.rowData)" aria-hidden="true" class="icon glyphicon glyphicon-edit"></span>
              </div>
            </template>

            <template slot="qrCode" slot-scope="props">
              <div class="vuestic-icon edit-icon text-center">
                <span
                  aria-hidden="true"
                  class="icon glyphicon glyphicon-qrcode tooltip-target b3"
                  @click="showLoginQR(props.rowData)"
                ></span>
              </div>
            </template>

            <template slot="loading" slot-scope="props">
              <spring-spinner
                slot="loading"
                :animation-duration="2500"
                :size="70"
              />
            </template>
          </templated-data-table>

          <vuestic-modal
            :show.sync="qrCodeToLogin"
            ref="qrLogin"
            :cancelClass="'none'"
            :okClass="'none'"
            @cancel="closeQRLogin"
          >
            <div slot="title">{{ `${$t('common.qrCode')} ${qrCodeCompanyTitle}` }}</div>
            <div>
              <qrcode-vue
                :value="qrCodeToLogin"
                :size="240"
                :class="'text-center tooltip-content'"
              ></qrcode-vue>
            </div>
          </vuestic-modal>
        </vuestic-widget>
      </div>
    </div>
  </div>
</template>

<script>
import ItemsPerPageDef from '../../vuestic-theme/vuestic-components/vuestic-datatable/data/items-per-page-definition'
import QueryParams from '../../vuestic-theme/vuestic-components/vuestic-datatable/data/query-params'
import { SpringSpinner } from 'epic-spinners'
import { QRURL } from '../../helpers'
import QrcodeVue from 'qrcode.vue'
import { VPopover } from 'v-tooltip'
import { createNamespacedHelpers } from 'vuex'
import TemplatedDataTable from '../../vuestic-theme/vuestic-components/vuestic-datatable/TemplatedDataTable'
const { mapGetters } = createNamespacedHelpers('app')

export default {
  name: 'Home',
  components: {
    SpringSpinner,
    TemplatedDataTable,
    QrcodeVue,
    VPopover,
  },
  computed: {
    ...mapGetters(['isLoading']),
    tableFields () {
      return [
        {
          name: '__slot:updatedAt',
          title: this.$t('common.table.date'),
          width: '15%',
        },

        {
          name: '__slot:title',
          dataClass: 'text-left',
          title: this.$t('common.table.companyName'),
          width: '40%',
        },

        {
          name: '__slot:unread',
          title: this.$t('common.table.documentCount'),
          width: '10%',
          dataClass: 'text-center',
        },

        {
          name: '__slot:edit',
          title: this.$t('common.table.edit'),
          width: '5%',
          titleClass: 'text-center',
        },

        {
          name: '__slot:qrCode',
          title: this.$t('common.qrCode'),
          width: '5%',
          titleClass: 'text-center',
        },
      ]
    },
  },
  data () {
    return {
      apiMode: false,
      tableData: { data: [] },
      itemsPerPage: ItemsPerPageDef.itemsPerPage,
      defaultTablePerPage: 6,
      paginationPath: '',
      initialPage: 1,
      qrCodeToLogin: '',
      qrCodeCompanyTitle: '',
      queryParams: QueryParams,
      documentsToPreview: [],
      currentDocumentIndex: 0
    }
  },
  watch: {
    currentDocumentIndex: function (val) {
      if (val != null) {
        this.$store.dispatch('document/openDocumentByIndex', val)
      }
    }
  },
  methods: {
    async dataProvider (pagination) {
      return this.$store.dispatch('companies/getCompanies', pagination)
    },

    openCompanyDetails (company) {
      this.$router.push({
        name: 'companyDetails',
        params: { companyId: company.id }
      })
    },
    showLoginQR (company) {
      this.qrCodeToLogin = this.getQR(company.number, company.pin.slice(0, 3), company.pin.slice(3))
      this.qrCodeCompanyTitle = company.title
      this.$refs.qrLogin.open()
    },
    editCompany (company) {
      this.$router.push({
        name: 'companyEdit',
        params: { companyId: company.id },
      })
    },
    getQR (num, a, b) {
      return QRURL(num, a, b)
    },
    closeQRLogin () {
      this.qrCodeToLogin = ''
      this.qrCodeCompanyTitle = ''
    }
  },
}
</script>

<style lang="scss">
#home-screen {
  .color-icon-label-table {
    td:first-child {
      width: 1rem;
    }
  }

  tr {
    .edit-icon {
      display: none;
      font-size: 18px;
    }
    &:hover .edit-icon {
      display: block;
      cursor: pointer;
    }
  }
}
</style>
